const isBrowser = () => typeof window !== "undefined";

const formatMetricValue = (metric) => {
  return metric.name === "CLS"
    ? Number(metric.value.toFixed(4))
    : Math.round(metric.value);
};

const resolveConnection = () => {
  if (typeof navigator === "undefined") {
    return undefined;
  }
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!connection || typeof connection.effectiveType !== "string") {
    return undefined;
  }
  return { type: connection.effectiveType };
};

export const buildWebVitalsPayload = (metric) => ({
  event: "web-vital",
  id: metric.id,
  name: metric.name,
  label: metric.label,
  value: formatMetricValue(metric),
  delta: typeof metric.delta === "number" ? metric.delta : undefined,
  page: isBrowser() ? window.location.pathname : undefined,
  originalValue: metric.value,
  connection: resolveConnection(),
});

const shouldDebugLog = (explicitDebug) => {
  if (explicitDebug === true) {
    return true;
  }
  if (explicitDebug === false) {
    return false;
  }
  return process.env.REACT_APP_WEB_VITALS_DEBUG === "true" || process.env.NODE_ENV !== "production";
};

const resolveEndpoint = (explicitEndpoint) => {
  if (explicitEndpoint) {
    return explicitEndpoint.trim();
  }
  const configured =
    process.env.REACT_APP_WEB_VITALS_ENDPOINT || process.env.NEXT_PUBLIC_WEB_VITALS_ENDPOINT || "";
  return configured.trim();
};

export const sendMetricToAnalytics = (metric, options = {}) => {
  const endpoint = resolveEndpoint(options.endpoint);
  const debug = shouldDebugLog(options.debug);
  const payload = buildWebVitalsPayload(metric);

  if (!endpoint) {
    if (debug) {
      console.info("[web-vitals]", payload.name, payload.value, payload);
    }
    return;
  }

  const body = JSON.stringify(payload);

  if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
    const success = navigator.sendBeacon(endpoint, body);
    if (!success && debug) {
      console.warn("[web-vitals] navigator.sendBeacon returned false", payload);
    }
    return;
  }

  if (typeof fetch === "function") {
    fetch(endpoint, {
      method: "POST",
      body,
      headers: { "Content-Type": "application/json" },
      keepalive: true,
    }).catch((error) => {
      if (debug) {
        console.warn("[web-vitals] Metric POST failed", error);
      }
    });
    return;
  }

  if (debug) {
    console.info("[web-vitals]", payload.name, payload.value, payload);
  }
};
